import React, { Component } from 'react';
import './styles.css';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Messages } from 'primereact/messages';
import { email } from '../../modulos/validation/email.js';
import { senha } from '../../modulos/validation/senha.js';
import { decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import { retornoHashValor } from '../../modulos/cripotografia/hash.js';

export default class ModificarSenha extends Component {
    constructor() {
        super();
        this.state = {
            email: '',
            senha: '',
            confirma_senha: '',
            erroForm: ''
        };
    }

  static displayname = 'Login';

  url = retornoHashValor(process.env.REACT_APP_1);

  mess = '';

  handleSubmit = e => {
      e.preventDefault();

      if (email(this.state.email).value === false) {
          this.showError(email(this.state.email).mess);

          return false;
      } else if (senha(this.state.senha).value === false) {
          this.showError(senha(this.state.senha).mess);

          return false;
      }

      const dataToSend = {
          Email: this.state.email,
          Senha: this.state.senha,
          Cpf: decriptoLocalStorage('cpf')?.decriptoValue,
          Codigo: decriptoLocalStorage('codigo')?.decriptoValue
      };

      fetch(`${this.url  }/auth-access`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(dataToSend)
      })
          .then(response => response.json())
          .then(responseJson => {
              if (responseJson.valido == true) {
                  localStorage.clear();
                  this.props.history.push('/login');
                  window.location.reload();
              } else {
                  if (responseJson.mess) {
                      this.showError(responseJson.mess);
                  } else {
                      this.showError('Email ou senha inválidos');
                  }
              }
          })
          .catch(err => {
              this.showError('Email ou senha inválidos');
          });
  }

  handleEmail = e => {
      this.setState({
          email: e.target.value
      });
  }

  handleSenha = e => {
      this.setState({
          senha: e.target.value
      });
  }

  handleConfirmaSenha = e => {
      this.setState({
          confirma_senha: e.target.value
      });
  }

  showError = mess => {
      this.messages.show({ sticky: false,
          severity: 'error',
          detail: mess });
  }

  clear = () => {
      this.messages.clear();
  }

  onBlurEmail = e => {
      if (email(e.target.value).value === false) {
          this.showError(email(e.target.value).mess);
      }
  }

  onBlurSenha = e => {
      if (senha(e.target.value).value === false) {
          this.showError(senha(e.target.value).mess);
      }
  }

  onBlurConfirmaSenha = e => {
      if (this.state.senha !== e.target.value) {
          this.showError('As senha não conferem');
      }
  }

  render() {
      return (
          <div className="content">
              <div className="content-content p-col-12 p-md-5 p-lg-4">
                  <form onSubmit={this.handleSubmit}>
                      <div className="p-float-label p-col-10">
                          <p>Modificar senha</p>
                      </div>
                      <span className="loading">
                      </span>

                      <div className="p-float-label p-col-10">
                          <Password id="senha" value={this.state.value} onBlur={this.onBlurSenha} onChange={this.handleSenha} name="nome_login" placeholder="Digite sua senha atual" />
                      </div>

                      <div className="p-float-label p-col-10">
                          <Password id="senha" value={this.state.value} onBlur={this.onBlurSenha} onChange={this.handleSenha} name="nome_login" placeholder="Digite sua nova senha" />
                      </div>

                      <div className=" p-col-10">
                          <Messages ref={el => this.messages = el}></Messages>
                      </div>

                      <div className="entrar p-float-label p-col-10">
                          <Button label="Modificar" type="submit" />
                      </div>

                  </form>
              </div>

          </div>
      );
  }
}
